module.exports = __webpack_public_path__ + "static/media/stamp_2.adf5e7c5.png";